// extracted by mini-css-extract-plugin
module.exports = {"globalKnowBtn":"message_globalKnowBtn__6uUPr"};